import { render, staticRenderFns } from "./SettingsRolePermissions.vue?vue&type=template&id=bf9d417c"
import script from "./SettingsRolePermissions.vue?vue&type=script&lang=js"
export * from "./SettingsRolePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports